/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Community || (M.Template.Community = {});
M.Template.Community.Util || (M.Template.Community.Util = {});

M.Template.Community.Util.ActivityFeedTile = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   *
   * CTAG:COMMUNITY:ACTIVITY_FEED
   */
__p+='\n\n<div class="feedContent">\n  <div class="userInfo floatL">\n    ';
 if (typeof userProfileUrl === 'undefined') { 
__p+='\n      <img class="userProfileImg floatL"\n          src="'+
((__t=( M.html.htmlAttributeEscape(userAvatarUrl) ))==null?'':__t)+
'">\n    ';
 } else { 
__p+='\n      <a href="'+
((__t=( M.html.htmlAttributeEscape(userProfileUrl) ))==null?'':__t)+
'">\n        <img class="userProfileImg floatL"\n            src="'+
((__t=( M.html.htmlAttributeEscape(userAvatarUrl) ))==null?'':__t)+
'">\n      </a>\n    ';
 } 
__p+='\n    <div class="userInfoText floatL">\n      <div class="nameLabel">\n      ';
 if (typeof userProfileUrl === 'undefined') { 
__p+='\n        '+
((__t=( M.html.htmlEscape(userName) ))==null?'':__t)+
'\n      ';
 } else { 
__p+='\n        <a href="'+
((__t=( M.html.htmlAttributeEscape(userProfileUrl) ))==null?'':__t)+
'">\n          '+
((__t=( M.html.htmlEscape(userName) ))==null?'':__t)+
'\n        </a>\n      ';
 } 
__p+='\n      </div>\n      <p class="activityDescription">'+
((__t=( M.html.htmlEscape(activityDescription) ))==null?'':__t)+
'</p>\n      <div class="activityCaption">\n        <img class="activityTypeIcon floatL"\n          src="'+
((__t=( M.img_src('/static/images/submission_icon_grey.svg') ))==null?'':__t)+
'">\n        <div class="activityCaption floatL">\n          '+
((__t=( M.html.htmlEscape(timingStr) ))==null?'':__t)+
'\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="activityPreview floatL">\n    ';
 if (hasCallout === true) { 
__p+='\n      <div class="activityCalloutContainer">\n        ';
 if (hasMessage === true) { 
__p+='\n          <div class="calloutText">\n            <i>'+
((__t=( M.html.htmlEscape(messagePreviewDisplay) ))==null?'':__t)+
'</i>\n          </div>\n        ';
 } 
__p+='\n        ';
 if (typeof(calloutUrl) !== 'undefined') { 
__p+='\n          <div class="activityCalloutActionLink">\n            <a href="'+
((__t=( M.html.htmlEscape(calloutUrl) ))==null?'':__t)+
'">\n              '+
((__t=( M.html.htmlEscape(calloutLinkText) ))==null?'':__t)+
'\n            </a>\n          </div>\n        ';
 } 
__p+='\n      </div>\n    ';
 } 
__p+='\n    ';
 if (hasThumbnail === true) { 
__p+='\n      ';
 if (typeof(activityLinkUrl) === 'undefined') { 
__p+='\n        <img class="activityThumbnail"\n          src="'+
((__t=( M.html.htmlAttributeEscape(activityThumbnailUrl) ))==null?'':__t)+
'">\n      ';
 } else { 
__p+='\n        <a class="activityThumbLink" href="'+
((__t=( M.html.htmlAttributeEscape(activityLinkUrl) ))==null?'':__t)+
'">\n          <img class="activityThumbnail"\n            src="'+
((__t=( M.html.htmlAttributeEscape(activityThumbnailUrl) ))==null?'':__t)+
'">\n        </a>\n      ';
 } 
__p+='\n    ';
 } 
__p+='\n  </div>\n</div>';
}
return __p;
});

M.Template.Community.Util.DropdownButton = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n<div class="dropdownButtonContainer">\n  <div class="dropdownButtonTrigger">\n    ';
 if (isButton) { 
__p+='\n      <button class="buttonFlat '+
((__t=( M.html.htmlAttributeEscape(buttonSize) ))==null?'':__t)+
' buttonGhost dropdownButtonButton">\n    ';
 } else { 
__p+='\n      <div class="dropdownText">\n        <a>\n    ';
 } 
__p+='\n        '+
((__t=( M.html.htmlAttributeEscape(buttonTextStr) ))==null?'':__t)+
'\n        <img class="sprite arrowDownGreyIcon"\n          src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'"/>\n    ';
 if (isButton) { 
__p+='\n      </button>\n    ';
 } else { 
__p+='\n        </a>\n      </div>\n    ';
 } 
__p+='\n  </div>\n  <div class="dropdownList">\n    <div class="dropdownListItemContainer">\n    </div>\n  </div>\n</div>\n\n';
}
return __p;
});

M.Template.Community.Util.DropdownListItemLink = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n<div class="dropdownListItem">\n  <div class="dropdownListItemLinkWrapper">\n    <a href="'+
((__t=( M.html.htmlAttributeEscape(listItemLink) ))==null?'':__t)+
'">\n      ';
 if (isButton) { 
__p+='\n        <h6>\n      ';
 } 
__p+='\n          '+
((__t=( M.html.htmlAttributeEscape(listItemLinkText) ))==null?'':__t)+
'\n      ';
 if (isButton) { 
__p+='\n        </h6>\n      ';
 } 
__p+='\n    </a>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Community.Util.DropdownListItemText = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n<div class="dropdownListItem">\n  <h6>'+
((__t=( M.html.htmlAttributeEscape(listItemText) ))==null?'':__t)+
'</h6>\n</div>';
}
return __p;
});

M.Template.Community.Util.EventTile = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:EVENTS
   */
__p+='\n\n<div class="eventInfo">\n  <p class="eventTitle nameLabel">'+
((__t=( M.html.htmlAttributeEscape(title) ))==null?'':__t)+
'</p>\n  <p class="eventDate">\n    <span class="startDate">'+
((__t=( M.html.htmlAttributeEscape(startDateStr) ))==null?'':__t)+
'</span>\n    ';
 if (endDateStr != "") { 
__p+='\n      to\n      <br />\n      <span class="endDate">'+
((__t=( M.html.htmlAttributeEscape(endDateStr) ))==null?'':__t)+
'</span>\n    ';
 } 
__p+='\n  </p>\n</div>\n<a class="button buttonFlat buttonGhost buttonMedium"\n  href="'+
((__t=( M.html.htmlAttributeEscape(facebook_url) ))==null?'':__t)+
'"\n  target="_blank">\n  view\n</a>\n';
}
return __p;
});

M.Template.Community.Util.InPageNavigationBar = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY
   */
__p+='\n\n<ul class="inPageNavList">\n  ';
 for (var i in inPageSections) { 
__p+='\n    ';
 if (tabSelectedIndex != undefined && tabSelectedIndex == i) { 
__p+='\n      <li class="inPageNavItem active">\n    ';
 } else { 
__p+='\n      <li class="inPageNavItem">\n    ';
 } 
__p+='\n      <a class="inPageNavLink"\n        href="'+
((__t=( M.html.htmlAttributeEscape(inPageSections[i]['sectionId']) ))==null?'':__t)+
'"\n      >\n        '+
((__t=( M.html.htmlAttributeEscape(inPageSections[i]['sectionTitle']) ))==null?'':__t)+
'\n      </a>\n    </li>\n  ';
 }; 
__p+='\n  <li class="inPageNavItem moreButtonContainer floatR"></li>\n</ul>\n';
}
return __p;
});

M.Template.Community.Util.ListPanel = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY
   */
__p+='\n\n<div class="listPanel">\n  <div class="panelHeader">\n    <h1 class="listTitle">'+
((__t=( M.html.htmlAttributeEscape(title) ))==null?'':__t)+
'</h1>\n    ';
 if (buttonText != "") { 
__p+='\n    <div class="buttonContainer">\n      <a class="button buttonFlat buttonGhost buttonMedium">\n        <span class="buttonLabel">'+
((__t=( M.html.htmlAttributeEscape(buttonText) ))==null?'':__t)+
'</span>\n      </a>\n    </div>\n    ';
 } 
__p+='\n  </div>\n  ';
 if (list.length == 0) { 
__p+='\n    <div class="emptyStateText">\n      '+
((__t=( M.html.htmlAttributeEscape(emptyPanelText) ))==null?'':__t)+
'\n    </div>\n  ';
 } 
__p+='\n</div>\n';
}
return __p;
});

M.Template.Community.Util.PayoneerRegistrationModal = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2018 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:DASHBOARD

*/
__p+='\n\n<div class="payoneerModal">\n  ';
/* Show the link to the Payoneer */
__p+='\n  ';
 if (model.get('generatedPayoneerLink')) { 
__p+='\n    <p>\n      Confirm your information below before continuing.\n    </p>\n  <div class="separator separator5"></div>\n  <ul>\n      <li>\n        <h3>Payee Type: </h3>\n        <p>'+
((__t=( M.html.htmlAttributeEscape(model.get('payeeType')) ))==null?'':__t)+
'</p>\n      </li>\n      ';
 if (model.get('payeeType') === 'Individual') { 
__p+='\n        <li>\n          <h3>First Name:</h3>\n          <p>'+
((__t=( M.html.htmlAttributeEscape(model.get('firstName')) ))==null?'':__t)+
'</p>\n        </li>\n        <li>\n          <h3>Last Name:</h3>\n          <p>'+
((__t=( M.html.htmlAttributeEscape(model.get('lastName')) ))==null?'':__t)+
'</p>\n        </li>\n      ';
 } 
__p+='\n      ';
 if (model.get('payeeType') === 'Business') { 
__p+='\n        <li>\n          <h3>Business Name:</h3>\n          <p>'+
((__t=( M.html.htmlAttributeEscape(model.get('businessName')) ))==null?'':__t)+
'</p>\n        </li>\n      ';
 } 
__p+='\n    </ul>\n    <ul class="buttonGroup floatR">\n      <li>\n        <a class="button buttonFlat buttonMedium buttonSecondary backButton">\n          Back\n        </a>\n      </li>\n      <li>\n        <a href=\n          "'+
((__t=( M.html.htmlAttributeEscape(model.get('generatedPayoneerLink')) ))==null?'':__t)+
'"\n           target="_blank"\n           class="button buttonFlat buttonPrimary buttonMedium payoneerLink">\n          Continue To Payoneer\n        </a>\n      </li>\n    </ul>\n  ';
 } else { 
__p+='\n    ';
/* Request info for Payoneer */
__p+='\n    <p class="bm">The information below will be used to verify your identity, process payments\n    and on your tax documents.  It must match your government-issued id or certification.\n    </p>\n    <form name="payoneerFields">\n      <ul>\n        <li>\n          <input type="radio" name="payeeType" class="payeeRadioInput"\n            value="Individual" id="indivRadioButton"\n            '+
((__t=( (model.get('payeeType') === 'Individual' ? 'checked="checked"' : '') ))==null?'':__t)+
'\n          />\n          <label for="indivRadioButton" class="payeeRadioLabel">\n            <span></span><p class="payeeDescription">Individual</p>\n          </label>\n\n        </li>\n        ';
 if (model.get('payeeType') === 'Individual') { 
__p+='\n          <li>\n            <input type="text" class="firstName inputTextField"\n              placeholder="First name"\n              value="'+
((__t=( M.html.htmlAttributeEscape(model.get('firstName'))))==null?'':__t)+
'"/>\n            <input type="text" class="lastName inputTextField" placeholder="Last name"\n              value="'+
((__t=( M.html.htmlAttributeEscape(model.get('lastName'))))==null?'':__t)+
'"/>\n          </li>\n        ';
 } 
__p+='\n        <li>\n          <input type="radio" name="payeeType" class="payeeRadioInput"\n            value="Business" id="businessRadioButton"\n          '+
((__t=( (model.get('payeeType') === 'Business' ? 'checked="checked"' : '') ))==null?'':__t)+
'\n          />\n          <label for="businessRadioButton" class="payeeRadioLabel">\n            <span></span><p class="payeeDescription">Business</p>\n          </label>\n        </li>\n        ';
 if (model.get('payeeType') === 'Business') { 
__p+='\n          <li>\n            <input type="text" class="businessName inputTextField"\n              placeholder="Business Name"\n              value="'+
((__t=( M.html.htmlAttributeEscape(model.get('businessName'))))==null?'':__t)+
'"/>\n          </li>\n        ';
 } 
__p+='\n        ';
 if (model.get('errorMsg')) { 
__p+='\n          <li class="warning">\n            '+
((__t=( M.html.htmlAttributeEscape(model.get('errorMsg'))))==null?'':__t)+
'\n          </li>\n        ';
 } 
__p+='\n      </ul>\n    </form>\n    <ul class="buttonGroup floatR">\n      <li>\n        <a class="button buttonFlat buttonPrimary buttonMedium submitPayoneer">\n          Confirm Payee Information\n        </a>\n      </li>\n    </ul>\n  ';
 } 
__p+='\n</div>\n';
}
return __p;
});

M.Template.Community.Util.ShowHide = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY
   */
__p+='\n\n<a class="toggleSwitch"></a>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
